import { useFilmOtt } from './use-film-ott';

export function usePrerollsDuration(contentId: string) {
    const film = useFilmOtt(contentId);

    return film?.onlineStreams?.streams?.[0]?.streamMeta?.prerollsDuration || 0;
}
